import { Paper } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';

import { formatDateToReadable } from '../../../shared/utils/format-date.util';
import { formatPrice } from '../../../shared/utils/format-price.util';
import capitalizeFirstLetter from '../../../shared/utils/capitalize-first-letter';
import { Order } from '../../types/order.type';
import OrderDeliveryTypeChip from '../Chips/OrderDeliveryTypeChip.component';
import DeliveryPointTypeChip from '../../../delivery-points/components/Chips/DeliveryPointTypeChip.component';
import { DELIVERY_POINT_TYPE, DeliveryPointType } from '../../../delivery-points/types/delivery-point.type';

const useStyles = makeStyles({
  root: {
    height: '100%',
  },
  paperRoot: {
    padding: '1rem',
    display: 'flex',
    height: 'calc(100% - 2rem)',
    flexDirection: 'column',
    gap: '0.5rem',

    '& p': {
      margin: 0,

      '& > span': {
        fontWeight: 'bold',
        color: '#424242',
      },
    },
  },
  typeChips: {
    display: 'flex',
    alignItems: 'center',
    gap: '0.5rem',
    flexWrap: 'wrap',
  },
});

const mapDeliverySubTypeToDeliveryPointType = (deliverySubType: string | null): DeliveryPointType | null => {
  switch (deliverySubType) {
    case 'company':
    case 'entreprise':
      return DELIVERY_POINT_TYPE.ENTREPRISE;
    case 'concierge':
    case 'conciergerie':
      return DELIVERY_POINT_TYPE.CONCIERGERIE;
    case 'relay':
      return DELIVERY_POINT_TYPE.RELAY;
    case 'eco':
      return DELIVERY_POINT_TYPE.ECO;
    default:
      return null;
  }
};

interface Props {
  order: Order;
}

export default function OrderDeliveryCard({ order }: Props) {
  const classes = useStyles();

  const { deliveryInfos, deliveryCost } = order;

  const deliverySubTypeAsRelayType = mapDeliverySubTypeToDeliveryPointType(deliveryInfos.deliverySubType);

  return (
    <section className={classes.root}>
      <h4>Livraison</h4>
      <Paper className={classes.paperRoot}>
        <div className={classes.typeChips}>
          <OrderDeliveryTypeChip deliveryType={deliveryInfos.deliveryType} />
          {deliverySubTypeAsRelayType && <DeliveryPointTypeChip type={deliverySubTypeAsRelayType} />}
        </div>
        <p>
          <span>Frais:</span> {deliveryCost > 0 ? formatPrice(deliveryCost) : 'Offert'}
        </p>
        <p>
          <span>Dépot:</span>
          {` ${capitalizeFirstLetter(formatDateToReadable(deliveryInfos.deliveryDate))} ${
            deliveryInfos.deliverySchedule && `(${deliveryInfos.deliverySchedule})`
          }`}
        </p>
        <p>
          <span style={{ display: 'block' }}>Adresse:</span>
          {deliveryInfos.deliveryAddress?.title && <p>{deliveryInfos.deliveryAddress.title}</p>}
          <p>{`${deliveryInfos.deliveryAddress.address} (${deliveryInfos.deliveryAddress.zipCode} - ${deliveryInfos.deliveryAddress.city})`}</p>
          {deliveryInfos.deliveryAddress?.complement && (
            <p>{`Complément: ${deliveryInfos.deliveryAddress.complement}`}</p>
          )}
          {deliveryInfos.deliveryAddress?.comment && (
            <p>{`Commentaire: ${deliveryInfos.deliveryAddress.complement}`}</p>
          )}
        </p>
      </Paper>
    </section>
  );
}
